<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Street Furniture</div>
				<div class="modal__head__subtitle">Recommended as default by RICS guidance note. </div>
			</div>
			<div class="modal__content">
				<ul>
					<div class="col md-6">
						<li>Barriers</li>
						<li>Belisha Beacons/special road crossings</li>
						<li>Bollards</li>
						<li>Bus stops, bus shelters</li>
						<li>Cabinet/Junction/control boxes</li>
						<li>Hoardings</li>
						<li>Lamp posts</li>
						<li>Mile posts</li>
					</div>
					<div class="col md-6">
						<li>Notice boards</li>
						<li>Posts</li>
						<li>Post boxes</li>
						<li>Road signs</li>
						<li>Telegraph/electricity poles</li>
						<li>Ticket machines</li>
						<li>Traffic signals</li>
						<li>Troughs</li>
					</div>
				</ul>
				<div class="clearfix"></div>
				<button class="primary" @click="closeModaler">Close</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'StreetFurnitureModal',
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/StreetFurnitureModal.vue